var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "icon-ecommerce" }, [
    _c(
      "svg",
      {
        attrs: {
          width: "100%",
          height: "100%",
          viewBox: "0 0 100 100",
          xmlns: "http://www.w3.org/2000/svg"
        }
      },
      [
        _c(
          "g",
          {
            attrs: {
              transform: "translate(9 9)",
              stroke: "#FFF",
              "stroke-width": "2",
              fill: "none",
              "fill-rule": "evenodd"
            }
          },
          [
            _c("path", {
              staticClass: "icon-ecommerce__path icon-ecommerce__path__path-1",
              attrs: {
                d:
                  "M42.3105,-0.0002 C18.9435,-0.0002 -0.000500000001,18.9428 -0.000500000001,42.3098 C-0.000500000001,65.6768 18.9435,84.6198 42.3105,84.6198 C65.6775,84.6198 84.6205,65.6768 84.6205,42.3098 C84.6205,18.9428 65.6775,-0.0002 42.3105,-0.0002",
                stroke: "#FFFFFF",
                "stroke-width": "2"
              }
            }),
            _c("g", { attrs: { transform: "translate(18 20)" } }, [
              _c("path", {
                staticClass:
                  "icon-ecommerce__path icon-ecommerce__path__path-2",
                attrs: {
                  d:
                    "M40.5048293,29.5222703 L9.0882439,29.5222703 L5.92397561,2.73524324 C5.79665854,1.65091892 4.86263415,0.832540541 3.75519512,0.832540541 L0.844463415,0.832540541"
                }
              }),
              _c("path", {
                staticClass:
                  "icon-ecommerce__path icon-ecommerce__path__path-2",
                attrs: {
                  d:
                    "M38.7995488,24.7408649 L8.52332927,24.7408649 L6.26345122,5.61437838 L42.5619878,5.61437838 C43.9833293,5.61437838 45.0260122,6.93005405 44.6802805,8.28789189 L40.918939,23.1105946 C40.6752805,24.0684324 39.801622,24.7408649 38.7995488,24.7408649 Z"
                }
              }),
              _c("path", {
                staticClass:
                  "icon-ecommerce__path icon-ecommerce__path__path-2",
                attrs: {
                  d:
                    "M40.5048293,35.6783784 C40.5048293,37.6589189 38.8760488,39.2643243 36.8653171,39.2643243 C34.8545854,39.2643243 33.2236098,37.6589189 33.2236098,35.6783784 C33.2236098,33.6978378 34.8545854,32.0924324 36.8653171,32.0924324 C38.8760488,32.0924324 40.5048293,33.6978378 40.5048293,35.6783784 Z"
                }
              }),
              _c("path", {
                staticClass:
                  "icon-ecommerce__path icon-ecommerce__path__path-2",
                attrs: {
                  d:
                    "M17.1870366,35.6783784 C17.1870366,37.6589189 15.5571585,39.2643243 13.5464268,39.2643243 C11.5356951,39.2643243 9.90471951,37.6589189 9.90471951,35.6783784 C9.90471951,33.6978378 11.5356951,32.0924324 13.5464268,32.0924324 C15.5571585,32.0924324 17.1870366,33.6978378 17.1870366,35.6783784 Z"
                }
              })
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13ef9d30", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13ef9d30","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/icons/icon-ecommerce-view.vue
// module id = 466
// module chunks = 79